export const recoverEn = {
  'recover-main-title': 'Recover Your Virtual Prepaid Card',
  'recover-main-text':
    'To recover your Virtual Prepaid Card details, please complete the mandatory fields below.',
  'recover-sectionOne-label': 'Why Recover Your Card?',
  'recover-sectionOne-p1-text':
    'If you have lost access to your Virtual Prepaid Card details, you can recover them here. This will allow you to view your card number, expiration date, and CVV again.',
  'recover-sectionOne-p2-text':
    'Please enter the same information you used when you originally activated your card to verify your identity.',
  'recover-form-error-alert':
    'There seems to be a problem. The information provided is incorrect in at least one of the fields. Please reach out to your card provider for assistance, contact details provided in the recovery email.',
  'recover-firstName-label': 'First Name',
  'recover-lastName-label': 'Last Name',
  'recover-email-label': 'Email',
  'recover-accessCode-label': 'Access Code',
  'recover-submit-button': 'Recover Card',
  'recover-invalidLink-title': 'Unable to Process Recovery Request...',
  'recover-invalidLink-text':
    'We are sorry, we are unable to process your recovery request. The link may have expired or is invalid. Please contact your card provider for assistance.',
  'recover-modal-title': 'Card Recovery',
  'recover-modal-text':
    'The next page will display your card details. Be sure to print or save the card number, CVV, and expiration date before exiting the page.',
  'recover-modal-proceed-text': 'Are you sure you want to recover your card details now?',
  'recover-modal-cancel-button': 'No',
  'recover-modal-proceed-button': 'Yes',
  'recovered-main-title': 'Your Virtual Card Details Have Been Recovered!',
  'recovered-sectionOne-label': 'Personal Card Information:',
  'recovered-name-label': 'Name:',
  'recovered-address-label': 'Address:',
  'recovered-cardNumber-label': 'Card Number:',
  'recovered-expiry-label': 'Expiration Date:',
  'recovered-cvv-label': '3 Digit Code (CVV):',
  'recovered-sectionTwo-p1-text':
    'Your card details have been recovered! Before closing this page, make sure to print or save your card information.',
  'recovered-sectionTwo-p2-text': 'How do I use my card?',
  'recovered-sectionTwo-li1-text':
    'Print or save this page for your records, these are your card details.',
  'recovered-sectionTwo-li2-text':
    'Make purchases online or over the phone, anywhere Visa/Mastercard is accepted.',
  'recovered-sectionTwo-li3-text':
    'Use your Personal Card Information when making purchases.',
  'recovered-sectionTwo-li4-text':
    'Check your balance and view your transaction history on the Cardholder site.',
  'recovered-sectionTwo-p4-text': 'Why Register my card?',
  'recovered-sectionTwo-li5-text':
    'Check card balance on Cardholder site.',
  'recovered-sectionTwo-li6-text':
    'View transaction history on the Cardholder site.',
  'recovered-sectionTwo-li7-text':
    'Update name and address associated to card.',
  'recovered-register-button': 'Register Card',
  'recovered-print-button': 'Print this Page'
};

export const recoverFr = {
  'recover-main-title': 'Récupérer votre carte prépayée virtuelle',
  'recover-main-text':
    'Pour récupérer les détails de votre carte prépayée virtuelle, veuillez remplir les champs obligatoires ci-dessous.',
  'recover-sectionOne-label': 'Pourquoi récupérer votre carte?',
  'recover-sectionOne-p1-text':
    'Si vous avez perdu l\'accès aux détails de votre carte prépayée virtuelle, vous pouvez les récupérer ici. Cela vous permettra de voir à nouveau votre numéro de carte, votre date d\'expiration et votre CVV.',
  'recover-sectionOne-p2-text':
    'Veuillez entrer les mêmes informations que vous avez utilisées lors de l\'activation initiale de votre carte pour vérifier votre identité.',
  'recover-form-error-alert':
    'Il semble y avoir un problème. Les informations fournies sont incorrectes dans au moins un des champs. Veuillez contacter votre fournisseur de carte pour obtenir de l\'aide. Vous trouverez ses coordonnées dans le courriel de récupération.',
  'recover-firstName-label': 'Prénom',
  'recover-lastName-label': 'Nom de famille',
  'recover-email-label': 'Courriel',
  'recover-accessCode-label': 'Code d\'accès',
  'recover-submit-button': 'Récupérer la carte',
  'recover-invalidLink-title': 'Impossible de traiter la demande de récupération...',
  'recover-invalidLink-text':
    'Nous sommes désolés, nous ne pouvons pas traiter votre demande de récupération. Le lien a peut-être expiré ou est invalide. Veuillez contacter votre fournisseur de carte pour obtenir de l\'aide.',
  'recover-modal-title': 'Récupération de carte',
  'recover-modal-text':
    'La page suivante affichera les détails de votre carte. Assurez-vous d\'imprimer ou de sauvegarder le numéro de carte, le CVV et la date d\'expiration avant de quitter la page.',
  'recover-modal-proceed-text': 'Êtes-vous sûr de vouloir récupérer les détails de votre carte maintenant?',
  'recover-modal-cancel-button': 'Non',
  'recover-modal-proceed-button': 'Oui',
  'recovered-main-title': 'Les détails de votre carte virtuelle ont été récupérés!',
  'recovered-sectionOne-label': 'Informations sur la carte:',
  'recovered-name-label': 'Nom:',
  'recovered-address-label': 'Adresse:',
  'recovered-cardNumber-label': 'Numéro de la carte:',
  'recovered-expiry-label': 'Date d\'expiration:',
  'recovered-cvv-label': 'Code à 3 chiffres (CVV):',
  'recovered-sectionTwo-p1-text':
    'Les détails de votre carte ont été récupérés! Avant de fermer cette page, assurez-vous d\'imprimer ou de sauvegarder les informations de votre carte.',
  'recovered-sectionTwo-p2-text': 'Comment utiliser ma carte?',
  'recovered-sectionTwo-li1-text':
    'Conservez une version imprimée ou téléchargée de cette page, elle reprend les détails de votre carte.',
  'recovered-sectionTwo-li2-text':
    'Faites vos achats en ligne ou par téléphone, chez tous les marchands qui acceptent Visa/Mastercard.',
  'recovered-sectionTwo-li3-text':
    'Utilisez les Données de votre carte personnelle lors de vos achats.',
  'recovered-sectionTwo-li4-text':
    'Vérifiez votre solde et consultez l\'historique de vos transactions sur le site du titulaire de carte.',
  'recovered-sectionTwo-p4-text': 'Pourquoi enregistrer ma carte?',
  'recovered-sectionTwo-li5-text':
    'Vous pouvez consulter le solde de votre carte sur le site du titulaire de carte.',
  'recovered-sectionTwo-li6-text':
    'Vous pouvez voir l\'historique de vos transactions sur le site du titulaire de carte.',
  'recovered-sectionTwo-li7-text':
    'Vous pouvez modifier le nom et l\'adresse associés à la carte.',
  'recovered-register-button': 'Enregistrer la carte',
  'recovered-print-button': 'Imprimer cette page'
};
